import type visitorsEn from "./visitors.en";

const visitorsFr: Record<keyof typeof visitorsEn, string> = {
  "admin.visitors.text1": "bots",
  "admin.visitors.text2": "Bot",
  "admin.visitors.text3": "humains",
  "admin.visitors.text4": "tous",
  "admin.visitors.text5": "IP débloquée (règle Cloudflare retirée)",
  "admin.visitors.text6": "IP débloquée localement, mais suppression Cloudflare en échec.",
  "admin.visitors.text7": "IP débloquée",
  "admin.visitors.text8": "Bloqué — règle Cloudflare appliquée",
  "admin.visitors.text9": "Blocage réseau impossible : Cloudflare non configuré ou refus API. La règle Actions (app) a été appliquée.",
  "admin.visitors.text10": "Réseau (ASN) bloqué",
  "admin.visitors.text11": "IP bloquée",
  "admin.visitors.text12": "Réseau (ASN) bloqué (niveau Actions)",
  "admin.visitors.text13": "IP bloquée (niveau Actions)",
  "admin.visitors.text14": "Enrichissement ISP/ASN en cours (peut prendre 1-2 min)...",
  "admin.visitors.text15": "Erreur lors de la recherche de l'adresse IP",
  "admin.visitors.text16": "Tous les logs ont été supprimés avec succès",
  "admin.visitors.text17": "Erreur lors de la suppression des logs",
  "admin.visitors.text18": "Chargement...",
  "admin.visitors.text19": "Visiteurs en temps réel",
  "admin.visitors.text20": "Analyse par IP",
  "admin.visitors.text21": "Enrichir ISP/ASN",
  "admin.visitors.text22": "Effacer tous les logs",
  "admin.visitors.text23": "Source :",
  "admin.visitors.text24": "Visites du site",
  "admin.visitors.text25": "Clics de liens",
  "admin.visitors.text26": "Tout",
  "admin.visitors.text27": "Humains actifs",
  "admin.visitors.text28": "En ligne maintenant (hors bots)",
  "admin.visitors.text29": "Humains aujourd'hui",
  "admin.visitors.text30": "Visites humaines",
  "admin.visitors.text31": "Bots aujourd'hui",
  "admin.visitors.text32": "Crawlers & monitoring",
  "admin.visitors.text33": "Pays",
  "admin.visitors.text34": "Pays différents",
  "admin.visitors.text35": "Visiteurs (regroupés par IP)",
  "admin.visitors.text36": "Détection des bots basée sur le User-Agent (Cloudflare, Googlebot, GPTBot, etc.)",
  "admin.visitors.text37": "Humains (",
  "admin.visitors.text38": "Bots (",
  "admin.visitors.text39": "Tous (",
  "admin.visitors.text40": "Aucun visiteur",
  "admin.visitors.text41": "Statut",
  "admin.visitors.text42": "IP",
  "admin.visitors.text43": "Navigateur",
  "admin.visitors.text44": "Fingerprint",
  "admin.visitors.text45": "Visites",
  "admin.visitors.text46": "Pages visitées",
  "admin.visitors.text47": "Première visite",
  "admin.visitors.text48": "Dernière activité",
  "admin.visitors.text49": "Actions",
  "admin.visitors.text50": "En ligne",
  "admin.visitors.text51": "Inactif",
  "admin.visitors.text52": "Vérifié",
  "admin.visitors.text53": "Reverse DNS confirmé",
  "admin.visitors.text54": "Non vérifié",
  "admin.visitors.text55": "Le UA prétend être un crawler connu mais le reverse DNS ne correspond pas.",
  "admin.visitors.text56": "PTR:",
  "admin.visitors.text57": "Requêtes durant les 5 dernières minutes",
  "admin.visitors.text58": "/5min",
  "admin.visitors.text59": "Lang:",
  "admin.visitors.text60": "CH:",
  "admin.visitors.text61": "Membre(s) déjà connecté(s) depuis cette IP",
  "admin.visitors.text62": "connexion",
  "admin.visitors.text63": "IP possiblement partagée (NAT, VPN, datacenter).",
  "admin.visitors.text64": "Réseau :",
  "admin.visitors.text65": "Catégorie :",
  "admin.visitors.text66": "· confiance",
  "admin.visitors.text67": "visite",
  "admin.visitors.text68": "page",
  "admin.visitors.text69": "Localiser l'IP",
  "admin.visitors.text70": "Bloquée",
  "admin.visitors.text71": " · Réseau",
  "admin.visitors.text72": " · Actions",
  "admin.visitors.text73": "Débloquer l'IP",
  "admin.visitors.text74": "Crawler vérifié — non bloquable",
  "admin.visitors.text75": "Crawler vérifié, non bloquable",
  "admin.visitors.text76": "Bloquer cette IP (Actions)",
  "admin.visitors.text77": "Bloquer totalement (réseau Cloudflare)",
  "admin.visitors.text78": "Bloquer le réseau ASN (Actions)",
  "admin.visitors.text79": "Bloquer totalement le réseau ASN (Cloudflare)",
  "admin.visitors.text80": "ASN bloqué",
  "admin.visitors.text81": "Débloquer",
  "admin.visitors.text82": "Bloquer (Actions)",
  "admin.visitors.text83": "Bloquer totalement (réseau)",
  "admin.visitors.text84": "Voir le User-Agent complet",
  "admin.visitors.text85": "visitée",
  "admin.visitors.text86": "Visites par heure (",
  "admin.visitors.text87": "Répartition des visites aujourd'hui",
  "admin.visitors.text88": "Navigateurs (",
  "admin.visitors.text89": "Répartition par navigateur / bot",
  "admin.visitors.text90": "Pages les plus visitées (",
  "admin.visitors.text91": "Top 5 aujourd'hui",
  "admin.visitors.text92": "Aucune donnée",
  "admin.visitors.text93": "visites",
  "admin.visitors.text94": "Pays (",
  "admin.visitors.text95": "visiteurs",
  "admin.visitors.text96": "Bloquer totalement ce réseau (ASN) ?",
  "admin.visitors.text97": "Bloquer totalement cette IP (réseau) ?",
  "admin.visitors.text98": "Bloquer ce réseau (ASN) — niveau Actions ?",
  "admin.visitors.text99": "Bloquer cette IP — niveau Actions ?",
  "admin.visitors.text100": "Cela ajoute une règle Cloudflare bloquant tout accès au site",
  "admin.visitors.text101": "depuis le réseau",
  "admin.visitors.text102": "depuis l'IP",
  "admin.visitors.text103": "Si Cloudflare n'est pas configuré, le blocage retombera automatiquement au niveau Actions.",
  "admin.visitors.text104": "Le réseau",
  "admin.visitors.text105": "sera bloqué au niveau",
  "admin.visitors.text106": "(inscription, contact, connexion). Les analytics restent enregistrées. Les crawlers vérifiés ne sont jamais bloqués.",
  "admin.visitors.text107": "L'IP",
  "admin.visitors.text108": "sera bloquée au niveau",
  "admin.visitors.text109": "(inscription, contact, connexion). Les analytics restent enregistrées.",
  "admin.visitors.text110": "Annuler",
  "admin.visitors.text111": "Bloquer totalement",
  "admin.visitors.text112": "Bloquer",
  "admin.visitors.text113": "Informations de géolocalisation IP",
  "admin.visitors.text114": "Détails de localisation pour l'adresse IP sélectionnée",
  "admin.visitors.text115": "Recherche en cours...",
  "admin.visitors.text116": "Adresse IP",
  "admin.visitors.text117": "Ville",
  "admin.visitors.text118": "Région",
  "admin.visitors.text119": "Code pays",
  "admin.visitors.text120": "Fuseau horaire",
  "admin.visitors.text121": "Fournisseur d'accès (ISP)",
  "admin.visitors.text122": "ASN",
  "admin.visitors.text123": "Confirmer la suppression",
  "admin.visitors.text124": "Êtes-vous sûr de vouloir supprimer tous les logs de visiteurs ? Cette action est irréversible.",
  "admin.visitors.text125": "Supprimer tout",
  "admin.visitors.text126": "User-Agent complet",
  "admin.visitors.text127": "Chaîne brute envoyée par le client",
  "admin.visitors.text128": "7 jours",
  "admin.visitors.text129": "30 jours",
  "admin.visitors.text130": "90 jours",
  "admin.visitors.text131": "Suspect",
  "admin.visitors.text132": "À surveiller",
  "admin.visitors.text133": "Normal",
  "admin.visitors.text134": "Erreur",
  "admin.visitors.text135": "Impossible de charger les données",
  "admin.visitors.text136": "Vérification des permissions…",
  "admin.visitors.text137": "Accès refusé",
  "admin.visitors.text138": "Cette page est réservée aux administrateurs.",
  "admin.visitors.text139": "Analyse &amp; accès IP",
  "admin.visitors.text140": "Comparer (",
  "admin.visitors.text141": "Actualiser",
  "admin.visitors.text142": "CSV (",
  "admin.visitors.text143": "Le panneau",
  "admin.visitors.text144": "Accès &amp; blocages",
  "admin.visitors.text145": "ne liste que les IP et ASN sur lesquels une règle existe (bloqué ou whitelisté). Le tableau d'analyse plus bas n'affiche que les IP ayant au moins «&nbsp;Min visites&nbsp;» sur la période sélectionnée — baissez ce seuil (ex. à 1) pour voir une IP peu active comme une simple visite mobile.",
  "admin.visitors.text146": "IPs uniques",
  "admin.visitors.text147": "Récurrentes (≥5 jours)",
  "admin.visitors.text148": "Bots détectés",
  "admin.visitors.text149": "\"Google-only\" (≥80 %)",
  "admin.visitors.text150": "/inscription ≥3 sans inscrire",
  "admin.visitors.text151": "Filtres",
  "admin.visitors.text152": "IP, ville, ISP, ASN…",
  "admin.visitors.text153": "Période",
  "admin.visitors.text154": "Min visites",
  "admin.visitors.text155": "Type de visiteur",
  "admin.visitors.text156": "Tous les visiteurs",
  "admin.visitors.text157": "Humains uniquement",
  "admin.visitors.text158": "Bots uniquement",
  "admin.visitors.text159": "Tous les pays",
  "admin.visitors.text160": "ISP",
  "admin.visitors.text161": "Tous les ISP",
  "admin.visitors.text162": "Masquer les membres connectés",
  "admin.visitors.text163": "IP affichée(s)",
  "admin.visitors.text164": "Aucune IP ne correspond aux critères.",
  "admin.visitors.text165": "Localisation",
  "admin.visitors.text166": "ISP / ASN",
  "admin.visitors.text167": "Sessions",
  "admin.visitors.text168": "Jours",
  "admin.visitors.text169": "Google",
  "admin.visitors.text170": "/inscription",
  "admin.visitors.text171": "Score",
  "admin.visitors.text172": "Dernière",
  "admin.visitors.text173": "Navigateur ayant prouvé une connexion authentifiée",
  "admin.visitors.text174": "Connexion authentifiée prouvée",
  "admin.visitors.text175": "IP copiée",
  "admin.visitors.text176": "ISP inconnu",
  "admin.visitors.text177": "Jours actifs",
  "admin.visitors.text178": "Google %",
  "admin.visitors.text179": "Activité quotidienne",
  "admin.visitors.text180": "Top pages",
  "admin.visitors.text181": "Top referrers",
  "admin.visitors.text182": "(direct)",
  "admin.visitors.text183": "User agents (",
  "admin.visitors.text184": "Première visite :",
  "admin.visitors.text185": "Dernière :",
  "admin.visitors.text186": "Comparaison (",
  "admin.visitors.text187": "IPs)",
  "admin.visitors.text188": "Comparaison côte-à-côte des indicateurs clés",
  "admin.visitors.text189": "Top pages :",
  "admin.visitors.text190": "Tout désélectionner",
  "admin.visitors.text191": "Présent sur ≥ 5 jours distincts",
  "admin.visitors.text192": "Plus de 20 visites au total",
  "admin.visitors.text193": "≥ 80 % du trafic vient de Google",
  "admin.visitors.text194": "Au moins 3 vues de /inscription",
  "admin.visitors.text195": "ISP corporate / hébergeur surveillé",
  "admin.visitors.text196": "Membre identifié (bonus de confiance)",
  "admin.visitors.text197": "Vue formulaire d'inscription",
  "admin.visitors.text198": "Page d'authentification",
  "admin.visitors.text199": "Lien de vérification cliqué",
  "admin.visitors.text200": "Accès zone admin",
  "admin.visitors.text201": "Accès espace membre",
  "admin.visitors.text202": "Page de contact",
  "admin.visitors.text203": "En-tête identité IP",
  "admin.visitors.text204": "KPIs (visites, sessions, etc.)",
  "admin.visitors.text205": "📊 Pourquoi ce score ?",
  "admin.visitors.text206": "📈 Activité quotidienne (graphique)",
  "admin.visitors.text207": "🚨 Événements clés",
  "admin.visitors.text208": "🕷️ Bots & défis Turnstile",
  "admin.visitors.text209": "🕒 Chronologie complète",
  "admin.visitors.text210": "accept-encoding sans gzip/br/deflate → client non-navigateur",
  "admin.visitors.text211": "accept-language vide → script probable",
  "admin.visitors.text212": "If-Modified-Since / ETag présent → pattern de monitoring",
  "admin.visitors.text213": "User-Agent d'outil automatisé détecté",
  "admin.visitors.text214": "Profil navigateur cohérent (UA connu + Brotli supporté)",
  "admin.visitors.text215": "Inspection mise à jour",
  "admin.visitors.text216": "Échec",
  "admin.visitors.text217": "Jour",
  "admin.visitors.text218": "Événements clés",
  "admin.visitors.text219": "Date",
  "admin.visitors.text220": "Type",
  "admin.visitors.text221": "Libellé",
  "admin.visitors.text222": "URL",
  "admin.visitors.text223": "Détail",
  "admin.visitors.text224": "Bots & défis Turnstile",
  "admin.visitors.text225": "User-Agent",
  "admin.visitors.text226": "Métadonnées",
  "admin.visitors.text227": "Chronologie complète",
  "admin.visitors.text228": "Page",
  "admin.visitors.text229": "Referrer",
  "admin.visitors.text230": "Session",
  "admin.visitors.text231": "Export HTML généré",
  "admin.visitors.text232": "Aucune donnée tabulaire",
  "admin.visitors.text233": "Cochez au moins une section tabulaire avec du contenu.",
  "admin.visitors.text234": "Export CSV généré",
  "admin.visitors.text235": "Accès réservé aux administrateurs.",
  "admin.visitors.text236": "Détails IP",
  "admin.visitors.text237": "Collectif Ibbü · Rapport d'analyse",
  "admin.visitors.text238": "Rapport d'activité IP",
  "admin.visitors.text239": "Généré le :",
  "admin.visitors.text240": "ID IP :",
  "admin.visitors.text241": "Période :",
  "admin.visitors.text242": "Retour à l'analyse par IP",
  "admin.visitors.text243": "Exporter en PDF",
  "admin.visitors.text244": "Sections à inclure",
  "admin.visitors.text245": "Choisissez ce qui apparaîtra dans le PDF.",
  "admin.visitors.text246": "Tout cocher",
  "admin.visitors.text247": "Tout décocher",
  "admin.visitors.text248": "Nom du fichier",
  "admin.visitors.text249": "Générer le PDF",
  "admin.visitors.text250": "Exports alternatifs (sections tabulaires)",
  "admin.visitors.text251": "HTML",
  "admin.visitors.text252": "CSV",
  "admin.visitors.text253": "HTML inclut un en-tête de rapport. CSV ne contient que les sections tabulaires cochées (timeline, événements, bots, chronologie).",
  "admin.visitors.text254": "Connexion authentifiée prouvée (aucun compte nommable)",
  "admin.visitors.text255": "Localisation inconnue",
  "admin.visitors.text256": "Visites / jour",
  "admin.visitors.text257": "Décomposition transparente des règles appliquées (max 100).",
  "admin.visitors.text258": "Score final / 100",
  "admin.visitors.text259": "Comportement détaillé",
  "admin.visitors.text260": "Top URLs, rafales, ressources sensibles, heatmap (30 j).",
  "admin.visitors.text261": "Aucune donnée.",
  "admin.visitors.text262": "Hits",
  "admin.visitors.text263": "Pages uniques",
  "admin.visitors.text264": "Ratio d'exploration",
  "admin.visitors.text265": "Rafales (≥3 hits < 2s)",
  "admin.visitors.text266": "Accès ressources sensibles",
  "admin.visitors.text267": "Top 20 URLs",
  "admin.visitors.text268": "Rafales détectées",
  "admin.visitors.text269": "hits",
  "admin.visitors.text270": "durée",
  "admin.visitors.text271": "crawl séquentiel",
  "admin.visitors.text272": "Heatmap jour × heure (30 j, Europe/Paris)",
  "admin.visitors.text273": "Signature HTTP",
  "admin.visitors.text274": "En-têtes capturés sur les requêtes de tracking. Inspection :",
  "admin.visitors.text275": "activée",
  "admin.visitors.text276": "désactivée",
  "admin.visitors.text277": "Désactiver l'inspection",
  "admin.visitors.text278": "Activer l'inspection",
  "admin.visitors.text279": "Aucune capture. Activez l'inspection puis attendez la prochaine requête de l'IP.",
  "admin.visitors.text280": "Dernière capture :",
  "admin.visitors.text281": "capture(s) au total",
  "admin.visitors.text282": "Les headers proviennent d'un XHR cross-origin vers une Edge Function. Les Client Hints (",
  "admin.visitors.text283": "sec-ch-ua*",
  "admin.visitors.text284": ") et les cookies de première partie ne sont pas transmis dans ce contexte — leur absence est normale et",
  "admin.visitors.text285": "n'est pas un signal de bot",
  "admin.visitors.text286": "✓ Aucun signal anormal — profil compatible navigateur réel.",
  "admin.visitors.text287": "Voir les en-têtes bruts (dernière capture)",
  "admin.visitors.text288": "📈 Activité quotidienne (30 derniers jours)",
  "admin.visitors.text289": "🚨 Événements clés (",
  "admin.visitors.text290": "Actions sensibles détectées sur cette IP (max 100 affichés).",
  "admin.visitors.text291": "Aucun événement sensible détecté.",
  "admin.visitors.text292": "🕷️ Bots & défis Turnstile (",
  "admin.visitors.text293": "Bloqué",
  "admin.visitors.text294": ": scrapers/archiveurs.",
  "admin.visitors.text295": "Autorisé",
  "admin.visitors.text296": ": crawlers IA.",
  "admin.visitors.text297": "Challenge",
  "admin.visitors.text298": ": captcha Turnstile requis / passé / échoué.",
  "admin.visitors.text299": "Aucun événement bot ou challenge pour cette IP.",
  "admin.visitors.text300": "Signature / Raison",
  "admin.visitors.text301": "Détails",
  "admin.visitors.text302": "Autorisé (IA)",
  "admin.visitors.text303": "Challenge requis",
  "admin.visitors.text304": "Challenge passé",
  "admin.visitors.text305": "Challenge échoué",
  "admin.visitors.text306": "même URL:",
  "admin.visitors.text307": "total:",
  "admin.visitors.text308": "🕒 Chronologie complète (",
  "admin.visitors.text309": "entrées)",
  "admin.visitors.text310": "Toutes les pages vues depuis cette IP, du plus récent au plus ancien.",
  "admin.visitors.text311": "Clics de liens courts par IP",
  "admin.visitors.text312": "Qui a cliqué sur vos liens, regroupé par adresse IP. Une IP peut regrouper plusieurs navigateurs : ouvrez-la pour voir l’état de chaque clic.",
  "admin.visitors.text313": "12 mois",
  "admin.visitors.text314": "Filtrer par IP",
  "admin.visitors.text315": "Aucun clic de lien enregistré sur cette période.",
  "admin.visitors.text316": "lien inconnu",
  "admin.visitors.text317": "clic(s)",
  "admin.visitors.text318": "visiteur(s)",
  "admin.visitors.text319": "identifiant(s) ·",
  "admin.visitors.text320": "vérifié(s)",
  "admin.visitors.text321": "lien(s)",
  "admin.visitors.text322": "VPN",
  "admin.visitors.text323": "Navigation privée",
  "admin.visitors.text324": "Clics sur les liens courts (",
  "admin.visitors.text325": "identifiant(s) de navigateur observé(s) depuis cette adresse IP, dont",
  "admin.visitors.text326": "vérifié(s). Une IP peut regrouper plusieurs navigateurs : l’état est indiqué clic par clic.",
  "admin.visitors.text327": "Aucun clic de lien depuis cette IP.",
  "admin.visitors.text328": "Robot",
  "admin.visitors.text329": "Appareil inconnu",
  "admin.visitors.text330": "directe",
  "admin.visitors.text331": "Visiteur :",
  "admin.visitors.text332": "Réseau bloqué ({label}) — niveau {scope}",
  "admin.visitors.text333": "Backfill terminé : {rows} lignes mises à jour ({resolved}/{total} IPs résolues).",
  "admin.visitors.text334": "Référent",
  "admin.visitors.text335": "Affichage limité aux 500 entrées les plus récentes",
  "admin.visitors.text336": "Comptes associés aux navigateurs observés depuis cette IP : {name}",
  "admin.visitors.text337": "Comptes observés : {name}",
  "admin.visitors.text338": "{count} jour(s) actif(s)",
  "admin.visitors.text339": "{count} visite(s)",
  "admin.visitors.text340": "{count} % depuis Google",
  "admin.visitors.text341": "{count} vue(s) /inscription",
  "admin.visitors.text342": "{count} section(s) exportée(s).",
  "admin.visitors.text343": "Comptes associés aux navigateurs observés : {name}",
  "admin.visitors.text344": "Dim",
  "admin.visitors.text345": "Lun",
  "admin.visitors.text346": "Mar",
  "admin.visitors.text347": "Mer",
  "admin.visitors.text348": "Jeu",
  "admin.visitors.text349": "Ven",
  "admin.visitors.text350": "Sam",
  "admin.visitors.text351": "dd/MM/yyyy 'à' HH:mm",
  "admin.visitors.text352": "Rapport surveillance IP",
  "admin.visitors.text353": "Collectif Ibbü · Rapport de surveillance",
  "admin.visitors.text354": "Rapport d'activité IP —",
  "admin.visitors.text355": "Généré le",
  "admin.visitors.text356": "Page ",
  "admin.visitors.text357": "{count} j",
  "admin.visitors.text358": " · confiance {value}",
  "admin.visitors.text359": " · requête {id}"
};

export default visitorsFr;
